export default function BackgroundFx() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"  // was -z-10
    >
      <div className="fx-aurora">
        <span className="fx-blob fx-blob1" />
        <span className="fx-blob fx-blob2" />
        <span className="fx-blob fx-blob3" />
        <span className="fx-blob fx-blob4" />
      </div>

      <div className="fx-beams">
        <span className="fx-beam fx-beam1" />
        <span className="fx-beam fx-beam2" />
      </div>

      <div className="fx-grid" />
      <div className="fx-grain" />
    </div>
  );
}
